// src/components/LanguageSelector.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LanguageSelector.css'; // on crée le style juste après
import { useState, useEffect } from "react";
import '../styles/styles.css';



const languages = [
  { code: 'fr', flag: '🇫🇷' },
  { code: 'en', flag: '🇬🇧' },
  { code: 'de', flag: '🇩🇪' },
  { code: 'es', flag: '🇪🇸' },
  { code: 'it', flag: '🇮🇹' },
  { code: 'pt', flag: '🇵🇹' },
  { code: 'nl', flag: '🇳🇱' },
  { code: 'el', flag: '🇬🇷' },
  { code: 'sv', flag: '🇸🇪' },
  { code: 'da', flag: '🇩🇰' },
  { code: 'no', flag: '🇳🇴' },
  { code: 'is', flag: '🇮🇸' },
  { code: 'fi', flag: '🇫🇮' },
  { code: 'uk', flag: '🇺🇦' },
  { code: 'pl', flag: '🇵🇱' },
  { code: 'ro', flag: '🇷🇴' },
  { code: 'hu', flag: '🇭🇺' },
  { code: 'sl', flag: '🇸🇮' },
  { code: 'cs', flag: '🇨🇿' },
  { code: 'sk', flag: '🇸🇰' },
  { code: 'hr', flag: '🇭🇷' },
 { code: 'mt', flag: '🇲🇹' },
  { code: 'lt', flag: '🇱🇹' },
  { code: 'et', flag: '🇪🇪' },
  { code: 'lv', flag: '🇱🇻' },
  { code: 'bg', flag: '🇧🇬' },
  { code: 'sr', flag: '🇷🇸' },
  { code: 'ar', flag: 'ع' }
 
  
];
const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

function LanguageSelector({ value, onChange }) {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);

  // valeur affichée : celle du profil si fournie, sinon fallback sur i18n
  const selected = value ?? i18n.language;

  const handleChange = (langCode) => {
    const isRTL = RTL_LANGUAGES.includes(langCode);
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', langCode);

    i18n.changeLanguage(langCode); // change l'interface tout de suite
    localStorage.setItem('lang', langCode);

    onChange?.(langCode); // remonte la sélection au parent (form)
    setOpen(false);
  };

//const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
useEffect(() => {
  const savedTheme = localStorage.getItem('theme') || 'light';
   applyTheme(savedTheme);
}, []);

const applyTheme = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
};

 return (
    <div className="language-selector">
      <div className="selected-item" onClick={() => setOpen(!open)}>
        {languages.find((l) => l.code === selected)?.flag}{' '}
        {t(`languages.${selected}`)}
      </div>
      {open && (
        <div className="dropdown-menu">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className={`dropdown-item ${lang.code === selected ? 'selected' : ''}`}
              onClick={() => handleChange(lang.code)}
            >
              {lang.flag} {t(`languages.${lang.code}`)}
            </div>
          ))}
        </div>
      )}
    </div>
  );

};

export default LanguageSelector;
